// extracted by mini-css-extract-plugin
export var active = "Reviews-module--active--3ff6e";
export var blueShape = "Reviews-module--blue-shape--17e03";
export var carousel = "Reviews-module--carousel--210e5";
export var container = "Reviews-module--container--f885d";
export var decorations = "Reviews-module--decorations--c95f9";
export var dots = "Reviews-module--dots--28b84";
export var dotsWrapper = "Reviews-module--dots-wrapper--1d251";
export var header = "Reviews-module--header--324a6";
export var orangeShape = "Reviews-module--orange-shape--43ee1";
export var outlined = "Reviews-module--outlined--d1b8c";
export var paddingContainer = "Reviews-module--padding-container--51e9a";
export var sliderWrapper = "Reviews-module--slider-wrapper--a2344";
export var yellowShape = "Reviews-module--yellow-shape--ae0ac";